<template>
    <div></div>
</template>
  
  <script>
  import axios from 'axios';
  import {mapState } from "vuex";

  export default {
    components: {},
    data(){
        return{
            ipAddress:"",
            cityName:'',
            userIp:'',
            ipAddress:{},
        }
    },
    created(){
        this.getUserIp();
    },
    methods:{
        getUserIp() {
            axios.get('https://api.ipify.org?format=json').then(response => {
                console.log(response,'获取IP地址')
                this.userIp = response.data.ip;
                axios.get(`https://api.vore.top/api/IPdata?ip=${response.data.ip}`)
                .then(response=>{
                    console.log(response,"获取位置")
                    if(response.data.code==200){
                        //返回的code是区域码，所以改为取城市名称
                        let cityNames = response.data.ipdata.info2.slice(0,-1);
                        this.$store.commit("setState",{ key: "currentCityCode", data:cityNames});
                        // console.log(response.data.adcode.a,"huoqude chengshi code ")
                    }
                }).catch(err=>{console.log(err,8888)})
            }).catch(error => {console.log(error);});
        },
    },
    computed: {
      ...mapState({
        positionArea:state => state.jobs.positionArea,
        hotJob: state => state.jobs.hotJob, 
        cityCodes:state => state.jobs.cityCodeText,
        currentCityCode:state => state.jobs.currentCityCode, //根据IP地址获取当前的城市code
      }),
    },
    watch:{
        positionArea:{
            handler(){
                if(this.positionArea && this.positionArea.length>0){
                    let result = this.positionArea.findIndex(item=>item.cityName == this.currentCityCode)
                    console.log(this.currentCityCode,result,'当前城市名称')
                    if(result !==  -1){
                        let codes = this.positionArea[result].cityCode;
                        this.$store.commit("setState",{ key: "cityCodeText", data:Number(codes)});
                    }
                    
                }
            },
        }
    },

    mounted() {}
  };
  </script>
  
  <style lang="scss">
  
  
  </style>
  